import { LifeCycleStatus } from '../enums';

export abstract class Model {
  // Keeping id type to 'any' to accommodate guid (string) and integer id values
  // tslint:disable-next-line: no-any
  constructor(public id?: any, public name?: Object, public status?: LifeCycleStatus, public eTag?: string) {}
  public abstract get className(): string;
  public abstract get apiPath(): string | undefined;
}
